"use client";

import { useState } from "react";

import { resolveActiveNavKey } from "@/lib/navigation/nav-items";

/**
 * The menu the current page belongs to: the one the rail marks as current and
 * the panel shows when nothing is pinned.
 *
 * A page two menus list (My Results and Execution both list the
 * conversations) stays with the menu it was opened from: the menu pinned open
 * when its link was clicked, or else the menu the last page was in. A fresh
 * load has no such menu and goes by route alone (`resolveActiveNavKey`).
 *
 * The menu is noted during the render that changes `pathname`, while
 * `pinnedKey` still names the menu that was open; SideNav clears the pin
 * after that render commits.
 */
export function useActiveNavKey(menus, pathname, pinnedKey) {
  const [opened, setOpened] = useState({ pathname, from: null });
  let from = opened.from;
  if (opened.pathname !== pathname) {
    from = menus.some((menu) => menu.key === pinnedKey)
      ? pinnedKey
      : resolveActiveNavKey(menus, opened.pathname, opened.from);
    setOpened({ pathname, from });
  }
  return resolveActiveNavKey(menus, pathname, from);
}
